import { connect } from 'react-redux';
import RoutesView from '../../components/views/RoutesView';

const mapStateToProps = state => ({
    isLoaded: state.catalogs.catalogIsLoaded
});

const mapDispatchToProps = dispatch => ({

});

const RoutesContainer = connect(mapStateToProps, mapDispatchToProps)(RoutesView);

export default RoutesContainer;
